import { jsx as C } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const l = (e) => /* @__PURE__ */ C(o, { ...e, children: /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.6794 12.6077C14.2982 11.0166 12.2651 10 9.99987 10C7.72363 10 5.69048 11.0055 4.32031 12.6077C5.30374 14.7624 7.48054 16.2541 9.99987 16.2541C12.5192 16.2541 14.685 14.7624 15.6794 12.6077ZM12.4864 6.87291C12.4864 8.2521 11.3683 9.37015 9.98912 9.37015C8.60993 9.37015 7.49188 8.2521 7.49188 6.87291C7.49188 5.49372 8.60993 4.37567 9.98912 4.37567C11.3683 4.37567 12.4864 5.49372 12.4864 6.87291Z"
  }
) });
export {
  l as User
};
//# sourceMappingURL=User.js.map
